<template>
	<div id="body-container">
		<NavBar  :class="{active:'bg-dark'}"/>
		<div class="SessionPopup">
			<SessionPopup />
		</div>
		<div class="overlay" :class="{ active: 'isOverlayActive' }" v-if="isSessionPopupVisible == true"></div> <!-- Overlay here -->

		<div class="flex bg-dark" @click="closeApps()">
			<div :class="{ 'w-40': isToggling, 'w-10': !isToggling,active:'bg-dark-blue' }">
				<MenuBar />	
			</div>
			<div class="content mt-12 flex-1 w-full h-screen overflow-y-scroll" :class="{ toggledstate: isToggling }"  @scroll="handleScroll($event)">
				<div :class="getPadding()">
					<slot />
				</div>
				<Footer/>
			</div>
		</div>	
	</div>
</template>
<style>
.padding100{
	margin-bottom: 100px;
	
}
.padding0{
	margin-bottom: 0px;
}
.SessionPopup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  border-radius: 8px;
  z-index: 999999; /* Ensure it's above other content */
}
.bg-dark.active {
  /* background-color:rgba(8, 8, 8, 0.5); */
  opacity:0.7;
  z-index:50;
}
.bg-dark-blue.active{
	/* background-color:rgba(0, 0, 0, 0.5); */
	opacity: 0.7;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8); /* Black with opacity */
  z-index: 9999;
  display: none; /* Initially hidden */
}

.overlay.active {
  display: block; /* Show the overlay when active */
}

</style>
<script lang="ts">
import NavBar from '../components/navBar.vue';
import MenuBar from '../components/sidemenubar.vue';
import Footer from '../components/footer.vue'


import { defineComponent } from 'vue';
import { emitter } from '../main';
import { mapGetters } from 'vuex';
import SessionPopup from '@/components/sessionpopup.vue';
export default defineComponent({
	data():any {
		return {
			isToggling: true,
			isSessionPopupVisible:false
		};
	},
	 computed:{
        ...mapGetters({ selectedOptionName: 'val',toggleState:'toggle' })
    },
	components: {
		NavBar,
		MenuBar,
		Footer,
		SessionPopup
	},
	methods:{
		closeApps(){
			this.appsVisible=false;
			emitter.emit('apps', this.appsVisible);
			},
		handleScroll(event:any) {
			if (this.$route.path.includes('/processInformation')||this.$route.path.includes('/organizationInformation')||this.$route.path.includes('/systemInformation')||this.$route.path.includes('/org/risks')||this.$route.path.includes('/org/threat')||this.$route.path.includes('/org/vulnerabilities')){
				emitter.emit('close-dropdown'); // Emit event to close dropdown on scroll
			}
		},
		getPadding(){
			if(this.$route.name == 'processInformation'||this.$route.name == 'organizationInformation'||this.$route.name == 'systemInformation'||this.$route.name=='informationRisks'||this.$route.name=='taskEditPage'){
				return 'padding0'
			} else {
				return 'padding100'
			}
		}
	},
	mounted() {
		this.isToggling = this.toggleState;
        emitter.on('toggle-sidebar', (isToggle: any) => {
            this.isToggling = isToggle;
        });
		emitter.off('isvisible');
		emitter.on('isvisible',(data:any)=>{
			this.isSessionPopupVisible = data;

		})
	},
});
</script>
